/// <reference path='_all.ts' />


// CHEAT SHEET: http://ivision.com/wp-content/uploads/AngularJS_v2.pdf

/**
 * The main TodoMVC app module.
 *
 * @type {angular.Module}
 */
module library {
  'use strict';

  var document = angular.module('library', ['photometerfilter', 'photometerdirective', 'navigation'])
    .controller('LibraryCtrl', LibraryCtrl)
    .controller('LibraryDetailCtrl', LibraryDetailCtrl)
    .controller('LibrarySortCtrl', LibrarySortCtrl)
    .controller('ToolboxCtrl', ToolboxCtrl)
    .controller('Toolbox2Ctrl', Toolbox2Ctrl)
    .controller('ProductFilterCtrl', ProductFilterCtrl)
    .directive('openDocumentDetail', OpenDocumentDetailDirective)
    .directive('libraryDetail', LibraryDetailDirective)
    .directive('libraryImageResize', LibraryImageResizeDirective)
    .filter('byDocument', ByDocumentFilter)
    .filter('unique', UniqueFilter)
    .filter('urlencode', UrlEncodeFilter)
    .filter('minssec', MinsSecFilter)
    .service('libraryService', LibraryService)
    .service('toolboxService', ToolboxService)
    .service('libraryDimensionService', LibraryDimensionService);
}



